import { useNavigate } from 'react-router-dom';
import { Dashboard } from '@practium/features/dashboard';
import type { DashboardVariant } from '@practium/features/dashboard';
import { useUserProfile } from '../../auth/hooks/useUserProfile';
import { getDashboardConfig } from '../utils/getDashboardConfig';
import { LoadingState } from '@practium/ui';
import { useForBinding } from '@practium/features/forBinding';
import { useGetDashboardInfos } from '@practium/features/api';

export const DashboardPage = () => {
	const navigate = useNavigate();
	const { userProfile, isLoading } = useUserProfile();
	const { isForBinding, forBindingUser } = useForBinding();
	const { data } = useGetDashboardInfos();

	if (isLoading) {
		return <LoadingState fullScreen />;
	}

	const effectiveVariant: DashboardVariant =
		isForBinding && forBindingUser ? (forBindingUser.role as DashboardVariant) : userProfile;

	const config = getDashboardConfig(
		effectiveVariant,
		navigate,
		data,
		isForBinding ? forBindingUser : undefined
	);

	return <Dashboard config={config} />;
};
